import nvSharedModelsModule from '../nv.shared.models.module';

angular
  .module(nvSharedModelsModule)

  .factory('StudentBulk', function($http, $rootScope, NvBaseModel, PublicConfig, SuccessToaster, ErrorToaster) {
    let StudentBulk = {
      patch(ids, patch) {
        return $http({
          method: 'PATCH',
          url: PublicConfig.NV_API_ORIGIN + '/v1/students/bulk',
          data: {
            _ids: ids,
            patch,
          },
          headers: {
            Accept: 'application/json',
          },
        }).then(
          function(res) {
            SuccessToaster.notificationToast(res);
            return res;
          },
          function(err) {
            // throw err
            ErrorToaster.showError(err);
          },
        );
      },
      patchField(ids, path, value) {
        let patch = NvBaseModel._setFieldByPath({}, path, value);
        return StudentBulk.patch(ids, patch);
      },
    };

    return StudentBulk;
  });
